var _rect, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.625,
    y: 6.125,
    width: 21.75,
    height: 12.75,
    rx: 1.125,
    stroke: "#909090",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92 15.031h.024l.007-.022.338-1.062h1.707l.344 1.063.007.021H10.094l-.014-.041-1.582-4.683-.008-.021h-.685l-.007.02L6.22 14.99l-.013.041H6.92zm6.361-.336h0c.242-.23.36-.554.36-.966 0-.298-.057-.55-.174-.752a1.01 1.01 0 00-.427-.418c.125-.1.225-.232.298-.396.083-.183.123-.393.123-.629 0-.385-.114-.69-.345-.912-.23-.226-.559-.336-.978-.336H10.465v4.745h1.773c.452 0 .802-.11 1.043-.336zm-.713-3.505h0c.115.1.175.25.175.458 0 .203-.06.354-.175.459-.112.1-.277.152-.5.152h-.89V11.03h.89c.222 0 .387.055.5.16zm2.73-.873v-.031h-1.454v.791h.74v3.954H15.297V10.317zm3.233 3.947v-.031h-1.619l.896-1.14c.229-.287.384-.544.466-.772.081-.226.122-.469.122-.726 0-.42-.115-.757-.349-1.005-.234-.248-.546-.371-.934-.371-.292 0-.558.07-.797.211-.235.137-.423.33-.562.58l-.011.021.016.017.456.468.028.03.02-.036c.186-.316.45-.473.795-.473.208 0 .36.057.463.164.103.109.157.267.157.48 0 .144-.028.29-.084.438h0a1.987 1.987 0 01-.31.514l-1.392 1.766-.007.008v.624H18.531v-.767zM7.53 13.203l.613-1.914.618 1.914H7.53zm5.393.439c0 .22-.061.379-.178.483-.118.106-.299.161-.547.161h-1.02v-1.289h1.02c.248 0 .428.056.546.161.118.105.18.264.18.484z",
    fill: "#919191",
    stroke: "#909090",
    strokeWidth: 0.063
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 12.25,
    r: 1,
    fill: "#919191"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 12.25,
    r: 1,
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/plate.c662d295.svg";
export { ForwardRef as ReactComponent };